import type { ApiErrorFieldValue } from "@core/types/errorResponse";

export function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((item) => typeof item === "string");
}

export function stringMessagesFromApiErrorFieldValue(
  value: ApiErrorFieldValue | undefined
): string[] {
  if (value === undefined) {
    return [];
  }
  if (isStringArray(value)) {
    return value.filter((m) => m.trim().length > 0);
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed.length > 0 ? [trimmed] : [];
  }
  return [];
}

export function formFieldErrorsFromApiErrors(
  errors: Record<string, ApiErrorFieldValue> | undefined
): Partial<Record<string, string[]>> {
  if (!errors) {
    return {};
  }
  const result: Partial<Record<string, string[]>> = {};
  for (const [field, value] of Object.entries(errors)) {
    const messages = stringMessagesFromApiErrorFieldValue(value);
    if (messages.length > 0) {
      result[field] = messages;
    }
  }
  return result;
}

export function hasFormFieldErrorMessages(
  fieldErrors: Partial<Record<string, string[]>>
): boolean {
  return Object.values(fieldErrors).some(
    (msgs) => Array.isArray(msgs) && msgs.some((m) => typeof m === "string" && m.trim().length > 0)
  );
}
